import React, { useState } from 'react';
import { ClipboardCheck, Copy, Database, ExternalLink } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from './ui/Button';
import { STUDENTS_TABLE_SQL, SUPABASE_PROJECT_REF } from '../utils/supabase';

/** Shown when the Supabase project has no `students` table yet. */
export function SupabaseSetupNotice() {
  const [copied, setCopied] = useState(false);
  const copySql = async () => {
    try {
      await navigator.clipboard.writeText(STUDENTS_TABLE_SQL);
      setCopied(true);
      toast.success('Setup SQL copied');
      setTimeout(() => setCopied(false), 2500);
    } catch {
      toast.error('Could not copy — select the SQL manually.');
    }
  };
  return <section className="glass rounded-3xl p-6" aria-label="Supabase setup required" data-id="element-469" data-mp="iydw8glxydip">
      <div className="flex items-start gap-3" data-id="element-470" data-mp="4xb71uzngn3k">
        <span className="grid h-10 w-10 shrink-0 place-items-center rounded-2xl bg-emerald-500/12 text-emerald-600" data-id="element-471" data-mp="4znz50z4gduc">
          <Database className="h-5 w-5" data-id="element-472" data-mp="bwz9cs54wb9o" />
        </span>
        <div className="min-w-0" data-id="element-473" data-mp="bvo9h3et7nnu">
          <h3 className="text-sm font-semibold tracking-tight text-foreground" data-id="element-474" data-mp="bytxsgfm6lii">One-time Supabase setup</h3>
          <p className="mt-1 text-sm text-muted-foreground" data-id="element-475" data-mp="kxp1nlv6rjin">
            This project has no <span className="font-mono" data-id="element-476" data-mp="kvkyx790wqjy">students</span> table yet. Run the SQL below once in the
            Supabase SQL editor and the dashboard will start recording immediately.
          </p>
        </div>
      </div>

      <pre className="mt-4 max-h-64 overflow-auto scrollbar-slim rounded-2xl border border-[var(--glass-hairline)] bg-white/60 p-4 font-mono text-[11px] leading-relaxed text-foreground dark:bg-black/30" data-id="element-477" data-mp="3kcss7dmxtytw">
        {STUDENTS_TABLE_SQL}
      </pre>

      <div className="mt-4 flex flex-col gap-2 sm:flex-row" data-id="element-478" data-mp="3tcp8aqv9hpdc">
        <Button onClick={copySql} className="h-10 rounded-xl brand-gradient px-5 text-white hover:opacity-95" data-id="element-479" data-mp="35nmvbwbkokp6">
          {copied ? <ClipboardCheck className="mr-2 h-4 w-4" data-id="element-480" data-mp="30plab5ul6bb2" /> : <Copy className="mr-2 h-4 w-4" data-id="element-481" data-mp="30mqs7kz1p2kt" />}
          {copied ? 'Copied' : 'Copy setup SQL'}
        </Button>
        <a href={`https://supabase.com/dashboard/project/${SUPABASE_PROJECT_REF}/sql/new`} target="_blank" rel="noopener noreferrer" className="inline-flex h-10 items-center justify-center gap-2 rounded-xl border border-[var(--glass-hairline)] px-5 text-sm font-medium text-foreground transition-colors hover:bg-white/60 dark:hover:bg-white/5" data-id="element-482" data-mp="14jud9w45bplg">
          <ExternalLink className="h-4 w-4" data-id="element-483" data-mp="lox6cclt7u9v" />
          Open SQL editor
        </a>
      </div>
    </section>;
}